import React from 'react';
import { ArraySlot } from 'react-plugin';
export function ControlPanelRowSlot({ slotProps, plugOrder }) {
    return (React.createElement(ArraySlot, { name: "controlPanelRow", slotProps: slotProps, plugOrder: plugOrder }));
}
